var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ReturnGoodsShowSection',{attrs:{"RG":_vm.RG,"createData":_vm.createData}})
}
var staticRenderFns = []

export { render, staticRenderFns }